import "./styles/App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useDataContext, AppProvidider } from "./utils/DataContext";
import { UploadProvider } from "./utils/UploadContext";

import SettingPage from "./pages/SettingPage/SettingPage";
import DatasetPage from "./pages/DatasetPage/DatasetPage";
import TagPage from "./pages/TagPage/TagPage";
import AcquisitionDataPage from "./pages/AcquisitionDataPage/AcquisitionDataPage";
import LabelsPage from "./pages/LabelsPage/LabelsPage";
import CVATPage from "./pages/CVATPage/CVATPage";
import LLMPage from "./pages/LLMPage/LLMPage";
import ModelPage from "./pages/PreLabelPage/PreLabelPage";
import ExportPage from "./pages/ExportPage/ExportPage";
import SignUpPage from "./pages/Auth/Signup/SignupPage";
import SignInPage from "./pages/Auth/Login/LoginPage";
import ErrorRatePage from "./pages/ErrorRatePage/ErrorRatePage";
import ETLPage from "./pages/ETLPage/ETLPage";
import LabelStudioPage from "./pages/LabelStudioPage/LabelStudioPage";
import FolderPage from "./pages/FolderPage/FolderPage";
import DataProcessingPage from "./pages/DataCleansingPage/DataCleansingPage";
import TrainPage from "./pages/TrainPage/TrainPage";
import NefPage from "./pages/NefPage/NefPage";
import NotFoundPage from "./components/NotFound/NotFoundPage";
import OrganizationPage from "./pages/Auth/OrganizationPage/OrganizationPage";

const basicRoutes = [
  <Route key="not-found" path="*" element={<NotFoundPage />} />,
  <Route key="home" path="/" element={<AcquisitionDataPage />} />,
  <Route key="signin" path="/signin" element={<SignInPage />} />,
  <Route key="signup" path="/signup" element={<SignUpPage />} />,
  <Route key="acquisition" path="/acquisition" element={<AcquisitionDataPage />} />,
  <Route key="data-processing" path="/data-processing" element={<DataProcessingPage />} />,
  <Route key="dataset" path="/dataset" element={<DatasetPage />} />,
  <Route key="pre-label" path="/pre-label" element={<ModelPage />} />,
  <Route key="labels" path="/labels" element={<LabelsPage />} />,
  <Route key="cvat" path="/cvat" element={<CVATPage />} />,
  <Route key="folder" path="/folder" element={<FolderPage />} />,
  <Route key="tag" path="/tag" element={<TagPage />} />,
  <Route key="label-studio" path="/label-studio" element={<LabelStudioPage />} />,
  <Route key="llm" path="/llm" element={<LLMPage />} />,
  <Route key="export" path="/export" element={<ExportPage />} />,
  <Route key="error-rate" path="/error-rate" element={<ErrorRatePage />} />,
  <Route key="etl" path="/ETL" element={<ETLPage />} />,
  <Route key="train" path="/train" element={<TrainPage />} />,
  <Route key="nef" path="/nef" element={<NefPage />} />,
  <Route key="organization" path="/organization" element={<OrganizationPage />} />,
  <Route key="setting" path="/setting" element={<SettingPage />} />,
];

const annotatorRoutes = [...basicRoutes];

const developerRoutes = [...annotatorRoutes];

const adminRoutes = [...developerRoutes];

const rolesToRoutes = {
  admin: adminRoutes,
  developer: developerRoutes,
  annotator: annotatorRoutes,
};

function App() {
  return (
    <AppProvidider>
      <UploadProvider>
        <AppChild />
      </UploadProvider>
    </AppProvidider>
  );
}

function AppChild() {
  const { role } = useDataContext();

  const currentRoutes = [
    ...(rolesToRoutes.hasOwnProperty(role) ? rolesToRoutes[role] : basicRoutes),
  ];

  return (
    <Router>
      <div className="App">
        <Routes>{currentRoutes}</Routes>
      </div>
    </Router>
  );
}

export default App;
